module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box box-success"
  }, [_c('div', {
    staticClass: "box-header title-boreder"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-link btn-lg",
    on: {
      "click": function($event) {
        return _vm.advancedSearch()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-filter"
  }), _vm._v("  Avanzado")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "filterContainer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group",
    attrs: {
      "id": "divAccount"
    }
  }, [_c('label', [_vm._v("Cuenta")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "value": this.selectedAccount,
      "selectLabel": "",
      "selectedLabel": "",
      "deselectLabel": "",
      "track-by": "name",
      "placeholder": this.selectedAccount.name,
      "allow-empty": false,
      "label": "name",
      "options": this.optionsAccount
    },
    on: {
      "input": _vm.onAccountSelect
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("\n                  No se encontraron resultados\n                ")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Tipo de Documento")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.documentType),
      expression: "documentType"
    }],
    staticClass: "form-control minimal",
    attrs: {
      "id": "ddlDocumentType"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.documentType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.onDocumentSelect]
    }
  }, _vm._l((this.optionDocumentType), function(type) {
    return _c('option', {
      key: type.code,
      domProps: {
        "value": type.code
      }
    }, [_vm._v("\n                  " + _vm._s(type.text) + "\n                ")])
  }), 0)])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Tipo Pedido")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.typeOrder),
      expression: "typeOrder"
    }],
    staticClass: "form-control minimal",
    attrs: {
      "id": "ddlTypeOrder"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.typeOrder = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((this.optionTypeOrder), function(type) {
    return _c('option', {
      key: type.code,
      domProps: {
        "value": type.code
      }
    }, [_vm._v("\n                  " + _vm._s(type.text) + "\n                ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Nro. de Documento")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.documentNumber),
      expression: "documentNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "documentNumber"
    },
    domProps: {
      "value": (_vm.documentNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.documentNumber = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 pull-center",
    staticStyle: {
      "padding-top": "25px"
    }
  }, [_c('button', {
    staticClass: "btn btn-sm btn-success btnAction btn-search",
    on: {
      "click": function($event) {
        return _vm.search()
      }
    }
  }, [_vm._v(" Buscar")])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showAdvance) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Nro. de Tracking")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trackingNumber),
      expression: "trackingNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "trackingNumber"
    },
    domProps: {
      "value": (_vm.trackingNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.trackingNumber = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Referencia de Pedido")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.referenceOrder),
      expression: "referenceOrder"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "referenceOrder"
    },
    domProps: {
      "value": (_vm.referenceOrder)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.referenceOrder = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group",
    attrs: {
      "id": "divClientSelect"
    }
  }, [_c('label', [_vm._v("Cliente/Proveedor")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "value": this.selectedClient,
      "selectLabel": "",
      "selectedLabel": "",
      "deselectLabel": "",
      "track-by": "code",
      "placeholder": this.selectedClient.text,
      "allow-empty": false,
      "label": "text",
      "options": this.optionsClient
    },
    on: {
      "input": _vm.onClientSelect
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("\n                    No se encontraron resultados\n                  ")])])], 1)])]) : _vm._e()])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "box box-success"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    attrs: {
      "id": "resultTable"
    }
  }, [_c('vuetable', {
    key: _vm.tableKey,
    ref: "vuetable",
    attrs: {
      "id": "resultTable",
      "api-mode": false,
      "fields": _vm.tableFields,
      "css": _vm.tableCSS.table,
      "noDataTemplate": "No se encontraron resultados",
      "data": _vm.tableData,
      "data-manager": _vm.dataManager,
      "pagination-path": "pagination"
    },
    on: {
      "vuetable:pagination-data": _vm.onPaginationData
    },
    scopedSlots: _vm._u([{
      key: "documentTypeCode",
      fn: function(props) {
        return [_c('div', {
          staticClass: "text-center"
        }, [(_vm.window.width > 750) ? _c('span', {
          class: _vm.documentTypeClass(props.rowData.documentTypeCode)
        }) : _vm._e()])]
      }
    }, {
      key: "documentTypeName",
      fn: function(props) {
        return [_c('div', {
          attrs: {
            "id": "TIPO"
          }
        }, [_c('span', [_vm._v(_vm._s(props.rowData.documentTypeName))])])]
      }
    }, {
      key: "documentNumber",
      fn: function(props) {
        return [_c('div', {
          attrs: {
            "id": "Número"
          }
        }, [_c('span', [_vm._v(_vm._s(props.rowData.documentNumber))])])]
      }
    }, {
      key: "documentDate",
      fn: function(props) {
        return [_c('div', {
          attrs: {
            "id": "Fecha"
          }
        }, [_c('span', [_vm._v(_vm._s(_vm._f("formatDate")(props.rowData.documentDate, "DD/MM/YYYY", true)))])])]
      }
    }, {
      key: "referenceOrder",
      fn: function(props) {
        return [_c('div', {
          attrs: {
            "id": "NumeroReferencia"
          }
        }, [_c('span', [_vm._v(_vm._s(props.rowData.referenceDocumentNumber1))])])]
      }
    }, {
      key: "trackingNumber",
      fn: function(props) {
        return [_c('div', {
          attrs: {
            "id": "NumeroTracking"
          }
        }, [_c('span', [_vm._v(_vm._s(props.rowData.trackingNumber))])])]
      }
    }, {
      key: "quantitiesDocument",
      fn: function(props) {
        return [_c('div', {
          attrs: {
            "id": "Cantidades",
            "align": "center"
          }
        }, [_c('span', [_vm._v(_vm._s(props.rowData.quantityComplete) + " / " + _vm._s(props.rowData.quantityTotal)), _c('span', {
          staticStyle: {
            "font-size": "12px"
          }
        }, [_vm._v(" " + _vm._s(props.rowData.minimumStockUnit))])])])]
      }
    }, {
      key: "supplierCustomerDescription",
      fn: function(props) {
        return [_c('div', {
          attrs: {
            "id": "Cliente"
          }
        }, [_c('span', [_vm._v(_vm._s(props.rowData.supplierCustomerDescription))])])]
      }
    }, {
      key: "progress",
      fn: function(props) {
        return [_c('div', {
          staticClass: "progressContainer text-center"
        }, [_c('div', [_c('strong', {
          staticClass: "progressInfo"
        }, [_vm._v(_vm._s(props.rowData.status) + " (" + _vm._s(props.rowData.progress) + "%)")])]), _vm._v(" "), _c('div', {
          staticClass: "progressBar"
        }, [(props.rowData.progress) ? _c('div', {
          staticClass: "progress table-bar-document"
        }, [_c('div', {
          class: 'progress-bar progress-bar-' + _vm.formatProgress(props.rowData.progress),
          style: ('width:' + props.rowData.progress + '%'),
          attrs: {
            "role": "progressbar",
            "aria-valuenow": props.rowData.progress,
            "aria-valuemin": "0",
            "aria-valuemax": "100"
          }
        })]) : _vm._e()])])]
      }
    }, {
      key: "tracking",
      fn: function(props) {
        return [(props.rowData.documentNumber) ? _c('div', {
          staticClass: "text-center botonVerDetalle2"
        }, [(_vm.window.width > 750) ? _c('router-link', {
          staticClass: "btn table-btn",
          attrs: {
            "to": {
              name: 'DocumentMonitoring',
              params: {
                selectedAccount: _vm.selectedAccount,
                documentNumber: props.rowData.documentNumber,
                documentType: props.rowData.documentTypeCode,
                minimumStockUnit: props.rowData.minimumStockUnit,
                address1: props.rowData.address1,
                trackingNumber: props.rowData.trackingNumber,
                referenceDocumentNumber1: props.rowData.referenceDocumentNumber1,
                codeOrderType: props.rowData.codeOrderType,
                orderType: props.rowData.orderType,
                showAdvanceMain: _vm.showAdvance
              }
            },
            "tag": "button"
          }
        }, [_c('span', {
          staticClass: "table-btn-icon"
        })]) : _vm._e(), _vm._v(" "), (_vm.window.width < 750) ? _c('router-link', {
          staticClass: "btn table-btn",
          attrs: {
            "to": {
              name: 'DocumentMonitoring',
              params: {
                selectedAccount: _vm.selectedAccount,
                documentNumber: props.rowData.documentNumber,
                documentType: props.rowData.documentTypeCode,
                minimumStockUnit: props.rowData.minimumStockUnit,
                address1: props.rowData.address1,
                trackingNumber: props.rowData.trackingNumber,
                referenceDocumentNumber1: props.rowData.referenceDocumentNumber1,
                codeOrderType: props.rowData.codeOrderType,
                orderType: props.rowData.orderType,
                showAdvanceMain: _vm.showAdvance
              }
            },
            "tag": "button"
          }
        }, [_c('span', {
          staticStyle: {
            "color": "#364A5D",
            "font-size": "14px",
            "font-weight": "bold"
          }
        }, [_vm._v("Ver detalles")])]) : _vm._e()], 1) : _vm._e()]
      }
    }])
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._v("\n       \n      "), (this.paginationData && _vm.paginationData.total > 0) ? [_c('strong', {
    staticStyle: {
      "color": "#364A5D",
      "paddin-left": "15px"
    }
  }, [_vm._v("\n        Mostrando documento " + _vm._s(this.paginationData.from > 1 ? this.paginationData.from : this.paginationData.from + (_vm.pageNumber - 1) * 10) + " a " + _vm._s(this.paginationData.to * this.pageNumber) + " de " + _vm._s(this.paginationData.total) + " en Total\n        ")])] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('vuetable-pagination', {
    ref: "pagination",
    attrs: {
      "css": _vm.tableCSS.pagination
    },
    on: {
      "vuetable-pagination:change-page": _vm.onChangePage
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header title-boreder"
  }, [_c('h3', {
    staticClass: "box-title title"
  }, [_vm._v(" Seguimiento de documento")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "box-title box-title-sub"
  }, [_c('img', {
    staticClass: "icon-space",
    staticStyle: {
      "padding-bottom": "7px"
    },
    attrs: {
      "src": "/static/img/icons/search.png"
    }
  }), _vm._v("Buscar Documento\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', {
    attrs: {
      "for": "dtDateRange"
    }
  }, [_vm._v("Desde - Hasta")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "icon-calendar"
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "dtDateRange",
      "mode": "text"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header title-boreder"
  }, [_c('h3', {
    staticClass: "box-title box-title-sub"
  }, [_c('img', {
    staticClass: "icon-space",
    staticStyle: {
      "padding-bottom": "3px"
    },
    attrs: {
      "src": "/static/img/icons/result.png"
    }
  }), _vm._v(" "), _c('span', [_vm._v("BUSCAR DOCUMENTO")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-31c15a10!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/monitoring/DocumentSearch.vue
// module id = 509
// module chunks = 1